import React from "react";
import "./sidebar.css";

export default function Sidebar({ isOpen, onClose, onNavigate }) {
  return (
    <>
      {/* Overlay */}
      <div 
        className={`sidebar-overlay ${isOpen ? "open" : ""}`} 
        onClick={onClose}
      ></div>

      {/* Sidebar Panel */}
      <div className={`sidebar-panel ${isOpen ? "open" : ""}`}>
        
        {/* Sidebar Header */}
        <div className="sidebar-header">
          <h2>Megamind</h2>
          <h3>Abacus Practice</h3>
        </div>

        {/* Sidebar Links */}
        <div className="sidebar-links">
          <div className="sidebar-item" onClick={onClose}>
            <span className="sidebar-icon">📋</span>
            <span>Login</span>
          </div>

          <div 
            className="sidebar-item active" 
            onClick={() => {
              onNavigate("selector");
              onClose();
            }}
          >
            <span className="sidebar-icon">🧮</span>
            <span>Practice</span>
          </div>

          <div className="sidebar-item" onClick={onClose}>
            <span className="sidebar-icon">💰</span>
            <span>Feedback</span>
          </div>
        </div>

        {/* Sidebar Footer */}
        <div className="sidebar-footer">
          Version 3.0
        </div>

      </div>
    </>
  );
}
